declare namespace $ {

	type $mol_string_button__value_shm_hitalama_map_widget_float_page_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_page['name'] >
		,
		ReturnType< $mol_string_button['value'] >
	>
	export class $shm_hitalama_map_widget_float_page extends $mol_page {
		Name( ): $mol_string_button
		content( ): readonly($mol_view)[]
		name( next?: string ): string
		title_content( ): readonly(any)[]
		body( ): ReturnType< $shm_hitalama_map_widget_float_page['content'] >
	}
	
}

//# sourceMappingURL=page.view.tree.d.ts.map